import React from "react";

const CRMModuleHeader = ({ icon: Icon, title, description, rightContent }) => (
  <div className="mb-6 md:mb-8">
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-4 md:mb-6 gap-4">
      <div className="flex items-center space-x-4 min-w-0">
        <div className="flex-shrink-0">
          <Icon className="w-6 md:w-8 h-6 md:h-8 text-blue-600" />
        </div>
        <div className="min-w-0">
          <h1 className="text-xl md:text-3xl font-bold text-gray-900 dark:text-white truncate">{title}</h1>
          <p className="text-xs md:text-sm text-gray-600 dark:text-gray-400 truncate md:truncate-none">{description}</p>
        </div>
      </div>
      {rightContent ? (
        <div className="flex items-center gap-3 text-xs md:text-sm text-gray-600 dark:text-gray-400">
          {rightContent}
        </div>
      ) : null}
    </div>
  </div>
);

export default CRMModuleHeader;
